<template>
  <div
    v-if="notes"
    class="appointment-notes q-pa-sm"
  >
    <hr-icon
      name="event_note"
      size="xs"
      :legacy-props="{ size: 'xs' }"
      class="q-mr-sm"
    />
    <div class="appointment-notes__content">
      <span
        ref="notesRef"
        :class="{
          'appointment-notes__collapsed': !isNotesExpanded,
        }"
      >
        {{ notes }}
      </span>
      <span
        v-if="shouldShowReadMore"
        class="appointment-notes__read-more"
        @click.stop="toggleNotes"
      >
        {{ isNotesExpanded ? $t('common.labelReadLess') : $t('common.labelReadMore') }}
      </span>
    </div>
  </div>
</template>

<script>
import { HrIcon } from 'src/design-system';

export default {
  name: 'AppointmentNotes',

  components: { HrIcon },

  props: {
    notes: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      shouldShowReadMore: false,
      isNotesExpanded: false,
    };
  },

  mounted() {
    this.checkNotesOverflow();
  },

  methods: {
    toggleNotes() {
      this.isNotesExpanded = !this.isNotesExpanded;
    }, // toggleNotes()

    checkNotesOverflow() {
      const el = this.$refs.notesRef;
      if (!el) {
        return;
      }

      const computedStyle = getComputedStyle(el);
      const lineHeight = parseFloat(computedStyle.lineHeight);
      const maxHeight = lineHeight * 2;

      this.shouldShowReadMore = el.scrollHeight > maxHeight;
    }, // checkNotesOverflow()
  },
};
</script>

<style scoped lang="scss">
.appointment-notes {
  display: flex;

  &__content {
    text-align: start;
  }

  &__collapsed {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  &__read-more {
    cursor: pointer;
    text-decoration: underline;
    margin-left: 4px;
  }

  &__collapsed + &__read-more {
    margin-left: 0;
  }
}
</style>
